import { makeStyles } from '@mui/styles';
import { colors } from '../../packages';

export const useStyles = makeStyles({
  drawer: {
    '& .MuiPaper-root': {
      maxWidth: '1000px !important',
    },
    '& .drawerBody': {
      padding: 0,
    },
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
  },
  content: {
    flex: 1,
    overflowY: 'auto',
  },
  header: {
    position: 'relative',
    padding: '1rem',
    borderBottom: `1px solid ${colors.neutral100}`,
    height: 80,
    alignContent: 'center',
  },
  headTitle: {
    fontSize: 24,
    lineHeight: '32px',
  },
  closeBtn: {
    '& svg': {
      width: 30,
    },
  },
});
